<template>
  <TContainer :mobile-full="true">
    <UCarousel v-slot="{ item }" :items="items" :ui="cottageCarousel">
      <UCard
        as="a"
        :ui="carouselCardFourWithoutBorder"
        :href="item.url"
        @click="emit('button-click', $event)"
      >
        <TLazyimg
          :src="item.src"
          alt=""
          :classes-img="cardLazyImgRounded"
          classes="aspect-w-3 aspect-h-2"
        />
        <template #footer>
          <TStars class="pb-1" :comments="item.comments" :stars="item.rate" />

          <TText variant="semibold" clamp="clamp1" classes="mb-0">
            {{ item.name }}
          </TText>

          <TText color="text-gray-600" classes="mb-0">
            {{ item.subtitle }}
          </TText>
          <div class="min-h-16 mb-1">
            <TText tag="div" size="sm" clamp="clamp3" classes="text-ellipsis">
              <div v-html="item.description" />
            </TText>
          </div>
          <div>
            <TText tag="span" variant="semibold"> {{ item.price }} </TText>
            <TText tag="span">
              {{ item.priceText }}
            </TText>
          </div>
          <UButton
            variant="solid"
            tabindex="-1"
            block
            :label="item.buttonText"
            class="mt-4 group-hover:opacity-80"
          />
        </template>
      </UCard>
    </UCarousel>
  </TContainer>
</template>
<script setup lang="ts">
import { cottageCarousel } from '~~/modules/design-system/utils/nuxt-ui-config/components/carousel'
import { carouselCardFourWithoutBorder } from '~~/modules/design-system/utils/nuxt-ui-config/components/card'
import { cardLazyImgRounded } from '~~/modules/design-system/components/t-lazyimg/constants/config'

export interface propsInterface {
  items: {
    url: string
    src: string
    name: string
    description: string
    price: string
    subtitle: string
    comments: number
    rate: number
    priceText: string
    buttonText: string
  }[]
}

defineProps<propsInterface>()

const emit = defineEmits(['button-click'])
</script>
